<template>
  <div v-show='data.hidden === false' class="col-sm-6 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      <div :id='data.id' class="h-subscriber-nocheck-style"><ejs-checkbox :ref="data.name+'Check'"></ejs-checkbox></div>
      <span v-show="getRequired" class="h-red-code">* </span>
      {{data.showName}}
    </div>
    <div>
      <ejs-datepicker :format='dateFormat' :readonly='data.readonly' :disabled='data.disabled' :value='data.value' 
        :name='data.name' v-model='params.paramVal' :locale="locale" @change="selectChange" :min='minDate' :max='maxDate' :allowEdit="false"></ejs-datepicker>
    </div>
    <!--<button @click="getData">GetParam</button>-->
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_Date',
  props: [
    'data',
    'opCode'
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      locale: localStorage.getItem('locale'),
      dateFormat: 'yyyy-MM-dd',
      minDate: null,
      maxDate: null,
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
    };
  },
  methods: {
    getData() {
      const _dateParamVal = this.params.paramVal instanceof Date ? this.params.paramVal.Format(this.dateFormat) : this.params.paramVal;
      return {
        name: this.params.name,
        paramVal: _dateParamVal
      }
    },
    selectChange() {
      try {
        this.changeFunc();
      } catch (e) {
        console.log('subscriber error. bind onChange Func error');
      }
    },
    setMin(value) {
      this.minDate = value;
    },    
    setMax(value) {
      this.maxDate = value;
    },
  },
  created() {
    this.$parseInitData();
  },
};
</script>

<style scoped>

</style>
